/**
 * Template for creating new exercises
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CheckedIcon from '@material-ui/icons/CheckCircle';
import NotCheckedIcon from '@material-ui/icons/HighlightOff';
import Button from '@material-ui/core/Button';
import { img } from '../../../config';

const useStyles = makeStyles(theme => ({
  menu: {
    textAlign: 'center',
    width: '100%',
    '& h2': {
      color: theme.palette.primary.main,
    },
    '& img': {
      width: 400,
      maxWidth: '100%',
      marginBottom: 20,
    },
    '& > div': {
      border: '3px solid #C3CCE9',
      width: 400,
      maxWidth: '100%',
      textAlign: 'center',
      cursor: 'pointer',
      borderRadius: 5,
      marginBottom: 5,
      padding: 5,
      background: '#fff',
      display: 'inline-block',
      '&:hover': {
        background: '#EFF3FA',
      },
    },
  },
  done: {
    color: '#1d9021',
    marginRight: 5,
    float: 'right',
  },
  notDone: {
    color: '#ccc',
    marginRight: 5,
    float: 'right',
  },
  '@media(max-width: 850px)': {

  }
}));

function Menu(props) {
  const classes = useStyles();
  const { complete, exercise, data, close, setState } = props;

  return (
    <div className={classes.menu}>
      <h2>Zrób to sam</h2>
      <img src={img('brain-lens.jpg')} alt='' />
      {data.map((ex, idx) => <div onClick={() => setState({ type: 'intro', idx })} key={`${exercise.identifier}-${idx}`}>
        <span>ĆWICZENIE {idx + 1}</span>
        {complete[idx] && <CheckedIcon className={classes.done}/>}
        {!complete[idx] && <NotCheckedIcon className={classes.notDone}/>}
      </div>)}
      <p className={classes.action}>
        <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
      </p>        
    </div>
  );
}

export default Menu;